/* eslint-disable @typescript-eslint/ban-ts-comment */
import axios from "axios";
import { debounce } from "lodash";
import { Trello } from "./trello";

const API_KEY = process.env.API_KEY;

let backupRestApi: Trello.PowerUp.RestApi | null = null;
// @ts-ignore
window.clearTrelloToken = function () {
  if (!backupRestApi) throw "Can't clear token - function not found";
  console.log("clearing Trello Token");
  backupRestApi?.clearToken();
};

export default function _getRestApi(
  t: Trello.PowerUp.IFrame
): Trello.PowerUp.RestApi {
  backupRestApi = !backupRestApi ? backupRestApiFactory(t) : backupRestApi;
  return backupRestApi;
}

function backupRestApiFactory(trelloIframe: Trello.PowerUp.IFrame) {
  const t = trelloIframe;
  let authorized: Promise<boolean> | null = null;

  function clearToken() {
    return t
      .remove("organization", "private", "token")
      .then(() => t.remove("board", "private", "token"));
  }

  function getToken(): Promise<string | undefined> {
    return t.get("organization", "private", "token").then((token) => {
      if (!token) {
        return t.get("board", "private", "token");
      } else {
        return token;
      }
    });
  }

  async function isAuthorized() {
    if (authorized !== null) {
      return authorized;
    }

    const delayedReset = () =>
      setTimeout(() => {
        authorized = null;
      }, 500);

    const promise = async () => {
      const token = await getToken();
      if (!token) {
        return false;
      }
      const isAuthorized = await isAuthorizedViaRest(t, token, clearToken);
      return !!isAuthorized;
    };

    authorized = !authorized ? promise() : authorized;
    delayedReset();
    return authorized;
  }

  // https://developer.atlassian.com/cloud/trello/power-ups/client-library/t-authorize/
  async function authorize(opt: { scope: string }) {
    const oauthUrl =
      "https://trello.com/1/authorize?expiration=never" +
      `&name=${encodeURIComponent(process.env.APP_NAME as string)}&scope=${
        opt.scope
      }&key=${process.env.API_KEY}&callback_method=fragment` +
      `&return_url=${encodeURIComponent(
        window.location.origin + window.location.pathname
      )}`;

    // const tokenLooksValid = function (token) {
    //   return /^[0-9a-f]{64}$/.test(token);
    // };

    const authorizeOpts = {
      height: 680,
      width: 580,
      // Removed validation since Trello can no-longer guarantee their structure. Jireh Lo thinks this might be the issue for some users that prevents them from authorizing: 
      // https://trello-lovers.slack.com/archives/C026C50TFK3/p1771601343769289?thread_ts=1771414966.877819&cid=C026C50TFK3, https://developer.atlassian.com/cloud/trello/changelog/#CHANGE-770
      // validToken: tokenLooksValid,
    };

    return t
      .authorize(oauthUrl, authorizeOpts)
      .then(function (token) {
        return t.set("organization", "private", "token", token).catch(() => {
          return t.set("board", "private", "token", token);
        });
      })
      .then(function () {
        // now that the token is stored, we can close this popup
        // you might alternatively choose to open a new popup
        return t.closePopup();
      });
  }

  return {
    getToken,
    clearToken,
    isAuthorized,
    authorize,
  };
}

// Debounced because each hanler will be called separatelly, thus possibility of multiple consecutive calls
const isAuthorizedViaRest = debounce(
  async (
    t: Trello.PowerUp.IFrame,
    token: string,
    clearToken: () => PromiseLike<void>
  ) => {
    const x = await axios
      .get(
        `https://api.trello.com/1/members/${
          t.getContext().member
        }/?key=${API_KEY}&token=${token}`
      )
      .catch(async (err) => {
        console.warn(err);
        console.warn("Resetting token");
        await clearToken();
        return null;
      });
    return !!x?.data;
  },
  500,
  { leading: true }
);
